var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-modal",
        {
          attrs: { active: _vm.showModal },
          on: {
            "update:active": function($event) {
              _vm.showModal = $event
            }
          }
        },
        [_c("sc-modal-tag", { attrs: { "show-modal": _vm.showModal } })],
        1
      ),
      _vm._v(" "),
      _c("sc-form", {
        ref: "form",
        attrs: { form: _vm.form, rules: _vm.rules },
        on: { submit: _vm.getTagsForm },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Transportadora",
                            prop: "logistic_provider"
                          }
                        },
                        [
                          _c("sc-logistic-provider-dropdown", {
                            model: {
                              value: fields.logistic_provider,
                              callback: function($$v) {
                                _vm.$set(fields, "logistic_provider", $$v)
                              },
                              expression: "fields.logistic_provider"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Método de entrega",
                            prop: "delivery_methods"
                          }
                        },
                        [
                          _c("sc-delivery-method-dropdown", {
                            attrs: {
                              "logistic-provider-id": fields.logistic_provider,
                              multiple: ""
                            },
                            model: {
                              value: fields.delivery_methods,
                              callback: function($$v) {
                                _vm.$set(fields, "delivery_methods", $$v)
                              },
                              expression: "fields.delivery_methods"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Tipo de Documento",
                            prop: "document_type"
                          }
                        },
                        [
                          _c(
                            "sc-select",
                            {
                              attrs: { expanded: "" },
                              model: {
                                value: fields.document_type,
                                callback: function($$v) {
                                  _vm.$set(fields, "document_type", $$v)
                                },
                                expression: "fields.document_type"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { selected: "", value: "cte_document" }
                                },
                                [_vm._v("CTe")]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "nfe_document" } },
                                [_vm._v("NFe")]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "nfs_document" } },
                                [_vm._v("NFS")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("sc-button", {
                        attrs: {
                          text: "Exportar para Excel",
                          loading: _vm.loading,
                          disabled: !isValid
                        },
                        on: { click: _vm.exportExcelTags }
                      }),
                      _vm._v(" "),
                      _c("sc-button", {
                        attrs: {
                          type: "submit",
                          theme: "primary",
                          text: "Consultar"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column has-text-right" },
              [
                _c("sc-button", {
                  attrs: { theme: "primary", text: "Gerar nova tag" },
                  on: {
                    click: function($event) {
                      _vm.createTag()
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "sc-table",
            {
              attrs: {
                data: _vm.tags,
                "per-page": _vm.pagination.limit,
                "default-sort": "tms_name",
                paginated: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c(
                        "sc-table-column",
                        {
                          attrs: {
                            label: "Intelipost",
                            field: "tms_name",
                            sortable: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(row.tms_name) + "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sc-table-column",
                        {
                          attrs: {
                            label: "Transportadora",
                            field: "logistic_provider_name",
                            sortable: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.logistic_provider_name) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sc-table-column",
                        {
                          attrs: {
                            label: "Tipo",
                            field: "taxes_type",
                            sortable: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.taxes_type) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sc-table-column",
                        {
                          attrs: {
                            label: "Tag Nomenclatura",
                            field: "tag_name",
                            sortable: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(row.tag_name) + "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sc-table-column",
                        {
                          attrs: {
                            label: "Tag Valor",
                            field: "tag_value",
                            sortable: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.tag_value) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sc-table-column",
                        { attrs: { label: "Ações" } },
                        [
                          _c("sc-button", {
                            attrs: {
                              confirm: "",
                              theme: "danger",
                              text: "Excluir"
                            },
                            on: {
                              click: function($event) {
                                _vm.deleteTag(row.id)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
                _vm.totalCount
                  ? _c("p", [
                      _c("strong", [_vm._v("Total de registros:")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.totalCount))])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "template",
                { attrs: { slot: "bottom-left" }, slot: "bottom-left" },
                [
                  _c("sc-table-per-page", {
                    model: {
                      value: _vm.pagination.limit,
                      callback: function($$v) {
                        _vm.$set(_vm.pagination, "limit", $$v)
                      },
                      expression: "pagination.limit"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { attrs: { slot: "empty" }, slot: "empty" },
                [_c("sc-table-empty")],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c86acc54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c86acc54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-from-to-xml-cte/ScFromToXmlCte.vue
// module id = null
// module chunks = 